import React from "react";
import WinnersPerformanceComponent from "./WinnersPerformance";

const WinnersPerformance = () => {
    return <WinnersPerformanceComponent />;
};

export default WinnersPerformance;
